document.addEventListener('DOMContentLoaded', function () {
  /* --- Input masks --- */
  var cpf = document.getElementById('lp_cpf');
  if (cpf) {
    cpf.addEventListener('input', function () {
      var d = this.value.replace(/\D/g, '').slice(0, 11);
      d = d.replace(/(\d{3})(\d)/, '$1.$2');
      d = d.replace(/(\d{3})(\d)/, '$1.$2');
      d = d.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      this.value = d;
    });
  }

  var cel = document.getElementById('lp_celular');
  if (cel) {
    cel.addEventListener('input', function () {
      var d = this.value.replace(/\D/g, '').slice(0, 11);
      this.value = d.length <= 10
        ? d.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3').trimEnd()
        : d.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3').trimEnd();
    });
  }

  var cep = document.getElementById('lp_cep');
  if (cep) {
    cep.addEventListener('input', function () {
      var d = this.value.replace(/\D/g, '').slice(0, 8);
      this.value = d.replace(/(\d{5})(\d{0,3})/, '$1-$2').replace(/-$/, '');
    });
  }

  /* --- Char counter --- */
  var resp = document.getElementById('lp_resposta');
  var cnt  = document.getElementById('lp_char_count');
  if (resp && cnt) {
    resp.addEventListener('input', function () {
      cnt.textContent = this.value.length + ' / 1000';
    });
  }

  /* --- Estado select floating label --- */
  var estado = document.getElementById('lp_estado');
  if (estado) {
    function syncEstado() {
      if (estado.value) {
        estado.setAttribute('data-has-value', '1');
      } else {
        estado.removeAttribute('data-has-value');
      }
    }
    estado.addEventListener('change', syncEstado);
    syncEstado();
  }

  /* --- Smooth scroll to #inscricao --- */
  document.querySelectorAll('a[href="#inscricao"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.getElementById('inscricao');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* --- data-bg: aplica background-image em desktop (>= 992px) --- */
  function applyDataBg() {
    var isDesktop = window.innerWidth >= 992;
    document.querySelectorAll('[data-bg]').forEach(function (el) {
      el.style.backgroundImage = isDesktop
        ? "url('" + el.getAttribute('data-bg') + "')"
        : '';
    });
  }
  applyDataBg();
  window.addEventListener('resize', applyDataBg);

  /* --- Ritual: click play to load iframe --- */
  var player  = document.querySelector('.lp-ritual__player');
  var playBtn = document.querySelector('.lp-ritual__play-btn');
  if (player && playBtn) {
    var videoUrl = player.getAttribute('data-video-url');
    if (videoUrl) {
      playBtn.addEventListener('click', function () {
        var iframe = document.createElement('iframe');
        iframe.src = videoUrl + (videoUrl.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        player.appendChild(iframe);
        player.classList.add('is-loaded');
      });
    }
  }
});
